module.exports = __webpack_public_path__ + "img/banner_en.dff4e495.jpg";